// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { wrapDisplayName } = require('client-v2/common/components/utils')
const tag = require('client-v2/common/utils/hyperscript')

/**
 * A Higher-Order-Component to convert Immutable props into plain JS Objects
 * @see https://redux.js.org/recipes/using-immutablejs-with-redux
 */
function withImmutableToJS(wrappedComponent) {
  function ImmutableToJS(props) {
    return tag(wrappedComponent, convertImmutablePropsToJS(props))
  }
  ImmutableToJS.displayName = wrapDisplayName('ImmutableToJS', wrappedComponent)
  return ImmutableToJS
}

function convertImmutablePropsToJS(props) {
  const newProps = {}
  for (let key of Object.keys(props)) {
    newProps[key] = Immutable.isImmutable(props[key])
    ? props[key].toJS()
    : props[key]
  }
  return newProps
}

module.exports = withImmutableToJS
